// import React, { useCallback } from 'react'
// import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
// import HomeTitle from "../components/HomeTitle/HomeTitle"
// import Table from "../components/Table/Table"
// import {  Col, Container, Row } from "react-bootstrap"
// import { useEffect, useState } from "react"
// import axios from "axios"
// import { useSelector } from "react-redux"
// import CustomBtn from '../components/CustomBtn/CustomBtn'
// import { toast, ToastContainer } from 'react-toastify';
// import "react-toastify/dist/ReactToastify.css";
// import Select from 'react-select';

// export default function MarkAttendance() {
//     const userinfo = useSelector((state) => state);
//     const [class_id, setClass_id] = useState('')
//     const [classItems, setClassItems] = useState([])
//     const [sessionsItems, setSessionsItems] = useState([])
//     const [studentsItems, setStudentsItems] = useState([])
//     const [selectedSemesterId, setSelectedSemesterId] = useState('')
//     const [session_id, setSession_id] = useState('')
//     const [sessionID, setSessionID] = useState('')
//       const [checkedIds, setCheckedIds] = useState([]);
    

//     const [attendance, setAttendance] = useState({});
//     const [stageLoading, setStageLoading] = useState('')
//     const year = new Date().getFullYear();
//     const today = new Date();
//     const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
//           const { currentLocal } = useSelector((state) => state.currentLocal);
    

//     const headerIterm = [
//         currentLocal.home.ID,
//         currentLocal.home.namePlaceholder,
//         currentLocal.home.status
//     ]
//     const options = [
//         { value: 'first', label:  currentLocal.home.firstsemster },
//         { value: 'second', label:  currentLocal.home.secondsemester},
//     ];
//     const getAllApis = useCallback(async () => {

//         await axios
//             .get(`https://nanosoft.space/taarteb/public/api/grade-categories`, {
//                 headers: {
//                     Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
//                 }
//             })
//             .then(async (res) => {
//               console.log(res.data.data.data);
              
//                 const options = res.data.data.data.map(item => ({
//                     value: item.id, 
//                     label: item.name
//                 }));

//                 setClassItems(options);


//             })
//             .catch((error) => {

                



//             });
// if(class_id){
// await axios
// .get(`https://nanosoft.space/taarteb/public/api/grades`, {
//     headers: {
//         Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
//     }
// })
// .then(async (res) => {
// console.log(class_id);
// const gradebyid=res.data.data.data.filter((item)=>item?.category==class_id?.label)
//   const options = gradebyid.map(item => ({
//         value: item.id, 
//         label: item.name ,
//     }));

//     setSessionsItems(options);


// })
// .catch((error) => {

    



// });
// }
//         if (class_id && selectedSemesterId&&session_id) {
//             await axios
                // .get(`https://nanosoft.space/taarteb/public/api/attendances?grade_id=${class_id.value}&year=${year}&day=${dayName.toLowerCase()}&semester=${selectedSemesterId.value}&stage_id=${session_id.value}`, {
//                     headers: {
//                         Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
//                     }
//                 })
//                 .then(async (res) => {
//                     setStudentsItems(res.data.data.students)


//                 })
//                 .catch((error) => {

                    



//                 });
//         }

//     }, [class_id, selectedSemesterId,session_id,userinfo.auth.userArray.access_token,year]);

//     useEffect(() => {

 
//         getAllApis()

//     }, [getAllApis])

//     const SaveAtt = async (e) => {
//         e.preventDefault();
//         console.log(attendance);
        
//         // setStageLoading(true)
//         // const toastId = "attendance-toast";
//         // try {
//         //     const response = await axios.post('https://nanosoft.space/taarteb/public/api/attendances', attendance, {
//         //         headers: { Authorization: `Bearer ${userinfo.auth.userArray.access_token}` },
//         //     });

//         //     toast.success(response.data.message, { toastId,position: "bottom-right", autoClose: 2000 });
//         //     setClass_id('')
//         //     setSelectedSemesterId('')
//         //     setSession_id('')
//         //     setStageLoading(false)
//         // } catch (error) {
//         //     console.error("Error:",toastId, error.response?.data || error.message);
//         //     toast.error("Failed to submit attendance!");
//         //     setStageLoading(false)

//         // }

//     }

//     const submitAttendance = async (attendanceData) => {
        
//         setAttendance(attendanceData)
//     };

//   const handleAttendanceChange = (studentId) => {
//     setAttendance((prev) => {
//       const updatedAttendance = {
//         ...prev,
//         [studentId]: prev[studentId] === 1 ? 0 : 1, // Toggle between 1 and 0
//       };

//       // Call the submit function with the latest state
//       setAttendance({
//         session_id: sessionID,
//         attendance: Object.keys(updatedAttendance).map((id) => ({
//           student_id: parseInt(id),
//           is_present: updatedAttendance[id],
//         })),
//       });

//       return updatedAttendance;
//     });
//   };
//     const customBody=<tbody>
//       {studentsItems.map((item)=>{
//         return(
//   <tr>
//         <td>{item?.id}</td>
//         <td>{item?.name}</td>
//         <td>
//                   <div className="form-check">
//                         <input
//                             type="checkbox"
//                             value={attendance[item.id]} // optional if needed
//                             checked={attendance[item.id] === 1}
//                             onChange={() => handleAttendanceChange(item.id)}
//                           />
//                         </div>
//         </td>
//       </tr>
//         )
//       })}
    
//     </tbody>



//   const toggleCheck = (id) => {
//     let updated;
//     if (checkedIds.includes(id)) {
//       updated = checkedIds.filter((x) => x !== id);
//     } else {
//       updated = [...checkedIds, id];
//     }
//     setCheckedIds(updated);
//     const today = new Date().toISOString().split('T')[0];
// setAttendance({
//         date: today,
//         attendance: Object.keys(attendance).map((id) => ({
//           student_id: parseInt(id),
//           is_present: attendance[id],
//         })),
//       })
//     // send updated array back to parent
//     // if (onCheckChange) onCheckChange(updated);
//   };




//     return (
//         <>
//             <ToastContainer />
//             <div className="px-0 my-3 w-100 dashboard_content">
//                 <Container>
//                     <div className="d-flex flex-column w-100">
//                         <AuthNavbar />
//                         <div className="mt-5 mx-3">
//                             <HomeTitle title={currentLocal.home.MarkAttendance} />
//                             <Row>
//                                 <Col md={4}>
//                                     <div className='mb-3'>
//                                         <Select
//                                             value={class_id}
//                                             onChange={(selectedOption) => setClass_id(selectedOption)}
//                                             options={classItems}
//                                             placeholder={currentLocal.home.SelectClass} 

//                                         />
//                                     </div>

//                                 </Col>
//                                   <Col md={4}>
           
//                                     <div className='mb-3'>
//                                         <Select
//                                             value={session_id}
//                                             onChange={(selectedOption) =>{
//                                                 setSessionID(selectedOption.id)
//                                                 setSession_id(selectedOption)}}
//                                             options={sessionsItems}
//                                             placeholder={currentLocal.home.SelectSession}

//                                         />
//                                     </div>
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className='mb-3'>
//                                         <Select
//                                             value={selectedSemesterId}
//                                             onChange={(selectedOption) => setSelectedSemesterId(selectedOption)}
//                                             options={options}
//                                             placeholder={currentLocal.home.SelectSemester}
//                                         />
//                                     </div>
                     
//                                 </Col>
                              
//                             </Row>

//                     <Table
//                                 data={studentsItems}
//                                 headerIterm={headerIterm}
//                                 onSubmitAttendance={submitAttendance} 
//                                 session_id={session_id.value}
//                                 sessionID={sessionID}
//                                 body={customBody}


//                             />
//                             {class_id && selectedSemesterId&&session_id&&studentsItems.length!==0&&
//                                 <div className='d-flex justify-content-center mt-4'>
//                                     <div className='w-50 save_btn'>
//                                         <CustomBtn text={stageLoading ? currentLocal.home.Loading : currentLocal.home.Save} disabled={stageLoading}  clickingFunction={SaveAtt} customWidth={"100%"}/>

//                                     </div>
//                                 </div>
//                             }


//                         </div>

//                     </div>
//                 </Container>
//             </div>
//         </>
//     )
// }


import React, { useCallback } from 'react'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import CustomTable from "../components/CustomTable/CustomTable"
import {  Col, Container, Row } from "react-bootstrap"
import { useEffect, useState } from "react"
import axios from "axios"
import { useSelector } from "react-redux"
import CustomBtn from '../components/CustomBtn/CustomBtn'
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

export default function MarkAttendance() {
    const userinfo = useSelector((state) => state);
    const [class_id, setClass_id] = useState('')
    const [classItems, setClassItems] = useState([])
    const [sessionsItems, setSessionsItems] = useState([])
    const [studentsItems, setStudentsItems] = useState([])
    const [selectedSemesterId, setSelectedSemesterId] = useState('')
    const [session_id, setSession_id] = useState('')
    const [sessionID, setSessionID] = useState('')

    const [attendance, setAttendance] = useState({});
    const [stageLoading, setStageLoading] = useState('')
    const year = new Date().getFullYear();
    const today = new Date();
    const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
          const { currentLocal } = useSelector((state) => state.currentLocal);
    

    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.namePlaceholder,
        currentLocal.home.status
    ]
    const options = [
        { value: 'first', label:  currentLocal.home.firstsemster },
        { value: 'second', label:  currentLocal.home.secondsemester},
    ];
    const getAllApis = useCallback(async () => {

        await axios
            .get(`https://nanosoft.space/taarteb/public/api/grade-categories`, {
                headers: {
                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                }
            })
            .then(async (res) => {
                const options = res.data.data.data.map(item => ({
                    value: item.id, 
                    label: item.name
                }));

                setClassItems(options);


            })
            .catch((error) => {

                



            });
if(class_id){
await axios
.get(`https://nanosoft.space/taarteb/public/api/grades`, {
    headers: {
        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
    }
})
.then(async (res) => {
  
const gradebyid=res.data.data.data.filter((item)=>item?.category==class_id?.label)
  const options = gradebyid.map(item => ({
        value: item.id, 
        label: item.name ,
    }));


    setSessionsItems(options);


})
.catch((error) => {

    



});
}
        if (class_id && selectedSemesterId&&session_id) {
            await axios
                .get(`https://nanosoft.space/taarteb/public/api/attendances?grade_id=${session_id.value}&year=${year}&day=${dayName.toLowerCase()}&semester=${selectedSemesterId.value}&stage_id=${class_id.value}`, {
                    headers: {
                        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                    }
                })
                .then(async (res) => {
                    setStudentsItems(res.data.data.students)


                })
                .catch((error) => {

                    



                });
        }

    }, [class_id, selectedSemesterId,session_id,userinfo.auth.userArray.access_token,year]);

    useEffect(() => {

 
        getAllApis()

    }, [getAllApis])

    const SaveAtt = async (e) => {
        e.preventDefault();
        setStageLoading(true)
        const toastId = "attendance-toast";
        try {
            const response = await axios.post('https://nanosoft.space/taarteb/public/api/attendances', attendance, {
                headers: { Authorization: `Bearer ${userinfo.auth.userArray.access_token}` },
            });

            toast.success(response.data.message, { toastId,position: "bottom-right", autoClose: 2000 });
            setClass_id('')
            setSelectedSemesterId('')
            setSession_id('')
            setStageLoading(false)
        } catch (error) {
            console.error("Error:",toastId, error.response?.data || error.message);
            toast.error("Failed to submit attendance!");
            setStageLoading(false)

        }

    }

    const submitAttendance = async (attendanceData) => {
        
        setAttendance(attendanceData)
    };

    return (
        <>
            <ToastContainer />
            <div className="px-0 my-3 w-100 dashboard_content">
                <Container>
                    <div className="d-flex flex-column w-100">
                        <AuthNavbar />
                        <div className="mt-5 mx-3">
                            <HomeTitle title={currentLocal.home.MarkAttendance} />
                            <Row>
                                <Col md={4}>
                                    <div className='mb-3'>
                                        <Select
                                            value={class_id}
                                            onChange={(selectedOption) => setClass_id(selectedOption)}
                                            options={classItems}
                                            placeholder={currentLocal.home.SelectClass} 

                                        />
                                    </div>

                                </Col>
                          
                                <Col md={4}>
           
                                    <div className='mb-3'>
                                        <Select
                                            value={session_id}
                                            onChange={(selectedOption) =>{
                                                setSessionID(selectedOption.id)
                                                setSession_id(selectedOption)}}
                                            options={sessionsItems}
                                            placeholder={currentLocal.home.SelectSession}

                                        />
                                    </div>
                                </Col>
                                      <Col md={4}>
                                    <div className='mb-3'>
                                        <Select
                                            value={selectedSemesterId}
                                            onChange={(selectedOption) => setSelectedSemesterId(selectedOption)}
                                            options={options}
                                            placeholder={currentLocal.home.SelectSemester}
                                        />
                                    </div>
                     
                                </Col>
                            </Row>

                            <CustomTable
                                data={studentsItems}
                                headerIterm={headerIterm}
                                onSubmitAttendance={submitAttendance} 
                                session_id={session_id.value}
                                sessionID={sessionID}


                            />
                            {class_id && selectedSemesterId&&session_id&&studentsItems.length!==0&&
                                <div className='d-flex justify-content-center mt-4'>
                                    <div className='w-50 save_btn'>
                                        <CustomBtn text={stageLoading ? currentLocal.home.Loading : currentLocal.home.Save} disabled={stageLoading}  clickingFunction={SaveAtt} customWidth={"100%"}/>

                                    </div>
                                </div>
                            }


                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
}
